import Menu from '../../components/Menu';
import styled, { createGlobalStyle } from "styled-components";


export default function Layout({ children }) {

    return (
        <Container>
            <GlobalStyle />
            <Menu />
            <HrStyled />
            <Content>{children}</Content>
        </Container>
    )
}

const Container = styled.div`
    width: 100%;
    max-width: 1180px;
    margin: 0 auto;
    padding: var(--space-4) var(--space-5);
    display: flex;
    flex-direction: column;

    #btn-submit {
        align-self: center;
        margin: var(--space-5) 0;
        padding: var(--space-2) var(--space-5);
        background: var(--color-primary);
        color: #fff;
        border: 1px solid var(--color-primary);
        border-radius: var(--radius-md);
        font-size: 1rem;
        font-weight: 600;
        cursor: pointer;
        transition: background 0.15s ease, transform 0.05s ease, box-shadow 0.15s ease;
        :hover {
            background: var(--color-primary-strong);
            border-color: var(--color-primary-strong);
            box-shadow: var(--shadow-sm);
        }
        :active { transform: translateY(1px); }
    }

    #btn-image {
        color: var(--color-primary);
        font-size: 0.9rem;
        padding: var(--space-1) var(--space-3);
        margin: var(--space-2);
        border: 1px solid var(--color-primary);
        border-radius: var(--radius-sm);
        background: #fff;
        cursor: pointer;
        transition: background 0.15s ease, color 0.15s ease;
        :hover {
            background: var(--color-primary);
            color: #fff;
        }
    }

    .head-compras {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: row;
        gap: var(--space-2);
        margin: var(--space-3) 0;

        button {
            border: 1px solid var(--color-primary);
            color: var(--color-primary);
            background: #fff;
            padding: var(--space-1) var(--space-3);
            border-radius: var(--radius-sm);
            font-size: 0.9rem;
            cursor: pointer;
            transition: background 0.15s ease, color 0.15s ease;
            :hover {
                background: var(--color-primary);
                color: #fff;
            }
        }
    }
`

const Content = styled.div`
    display: flex;
    flex-direction: column;
    gap: var(--space-2);
    width: 100%;
`


export const GlobalStyle = createGlobalStyle`
    :root {
        --color-primary: #f46d2b;
        --color-primary-soft: #fff2e8;
        --color-primary-strong: #d8541a;
        --color-bg: #fafafa;
        --color-surface: #ffffff;
        --color-text: #1a1a1a;
        --color-muted: #6b7280;
        --color-border: #e5e7eb;
        --color-danger: #dc2626;

        --radius-sm: 6px;
        --radius-md: 10px;
        --radius-lg: 14px;

        --shadow-sm: 0 1px 2px rgba(0,0,0,0.05), 0 1px 3px rgba(0,0,0,0.06);
        --shadow-md: 0 4px 6px -1px rgba(0,0,0,0.08), 0 2px 4px -2px rgba(0,0,0,0.06);
        --shadow-lg: 0 10px 15px -3px rgba(0,0,0,0.1), 0 4px 6px -4px rgba(0,0,0,0.05);

        --space-1: 4px;
        --space-2: 8px;
        --space-3: 12px;
        --space-4: 16px;
        --space-5: 24px;
        --space-6: 32px;

        --font-sans: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
    }

    html, body, #root, #app {
        min-height: 100%;
        height: 100%;
        width: 100%;
    }

    body {
        margin: 0;
        padding: 0;
        font-family: var(--font-sans);
        font-size: 16px;
        line-height: 1.5;
        color: var(--color-text);
        background: var(--color-bg);
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        overflow-x: hidden;
    }

    * { box-sizing: border-box; }

    h1, h2, h3, h4 {
        color: var(--color-text);
        font-weight: 600;
        line-height: 1.25;
        margin: var(--space-4) 0 var(--space-3);
    }
    h1 { font-size: 1.75rem; }
    h2 { font-size: 1.4rem; }
    h3 { font-size: 1.15rem; color: var(--color-primary); }
    h4 { font-size: 1rem; }

    img { margin: var(--space-2); max-width: 100%; }

    a {
        color: inherit;
        text-decoration: none;
    }

    button {
        font-family: inherit;
        background: none;
        border: none;
        cursor: pointer;
        :focus-visible {
            outline: 2px solid var(--color-primary);
            outline-offset: 2px;
        }
    }

    input, select, textarea {
        font-family: inherit;
        font-size: 1rem;
        padding: var(--space-2) var(--space-3);
        border: 1px solid var(--color-border);
        border-radius: var(--radius-sm);
        background: var(--color-surface);
        color: var(--color-text);
        transition: border-color 0.15s ease, box-shadow 0.15s ease;
        :focus {
            outline: none;
            border-color: var(--color-primary);
            box-shadow: 0 0 0 3px var(--color-primary-soft);
        }
    }

    form {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        gap: var(--space-2);
        width: 100%;
    }

    label {
        font-size: 0.95rem;
        color: var(--color-muted);
    }

    ::selection {
        background: var(--color-primary-soft);
        color: var(--color-primary-strong);
    }
`


export const FormStyled = styled.div`
    width: 100%;
    font-size: 1rem;

    input, select {
        font-size: 1rem;
        margin: var(--space-1) 0;
    }

    #input-num {
        width: 5rem;
    }

    .input-custom {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        text-align: center;
        gap: var(--space-1);
        margin: var(--space-2) 0;
    }

    .input-curso {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        text-align: center;
        max-width: 95%;
        gap: var(--space-1);
        margin: var(--space-2) 0;
    }

    .input-sinopsis {
        font: unset;
        font-size: unset;
        font-family: unset;
        display: flex;
        max-width: 95%;
    }

    .form-error {
        color: #b00020;
        font-weight: bold;
        text-align: center;
    }
`

export const CardStyled = styled.div`
    font-size: 1rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: row;
    width: 100%;
    margin: 0;
    padding: var(--space-3) var(--space-4);
    background: var(--color-surface);
    border: 1px solid var(--color-border);
    border-left: 3px solid transparent;
    border-radius: var(--radius-md);
    box-shadow: var(--shadow-sm);
    cursor: pointer;
    transition: transform 0.1s ease, box-shadow 0.15s ease, border-color 0.15s ease, color 0.15s ease;

    :hover {
        color: var(--color-primary);
        border-left-color: var(--color-primary);
        box-shadow: var(--shadow-md);
        transform: translateY(-1px);
    }

    @media (max-width: 1024px) {
        flex-direction: column;
        text-align: center;
        gap: var(--space-2);
    }
`

export const HeadStyled = styled.div`
    font-size: 0.8rem;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    font-weight: 600;
    color: var(--color-muted);
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: row;
    width: 100%;
    margin: var(--space-3) 0 var(--space-1);
    padding: var(--space-2) var(--space-4);
    border-bottom: 1px solid var(--color-border);
`

const HrStyled = styled.hr`
    border: none;
    background: var(--color-primary);
    height: 2px;
    width: 100%;
    padding: 0;
    margin: var(--space-3) 0 var(--space-4);
`
